import React from 'react';
import { PropTypes } from 'prop-types';
import config from 'config';

import { StripeProvider, Elements } from 'react-stripe-elements';

import CardForm from 'refactored/features/soForm/steps/card/creditCard/Form/components/CardForm';

class Form extends React.Component {
  constructor() {
    super();
    this.state = { stripe: null };
  }

  componentDidMount() {
    const { country } = this.props;
    const countryCode = (country && country.country) || false;
    const stripeKey =
      Object.keys(config.STRIPE_KEY).indexOf(countryCode) >= 0
        ? config.STRIPE_KEY[countryCode]
        : config.DEFAULT_STRIPE_KEY;

    if (window.Stripe) {
      this.setState({ stripe: window.Stripe(stripeKey) });
    } else {
      document.querySelector('#stripe-js').addEventListener('load', () => {
        this.setState({ stripe: window.Stripe(stripeKey) });
      });
    }
  }

  render() {
    const { className, t } = this.props;
    const { stripe } = this.state;
    return (
      <div className={className}>
        <h1>{t('title')} </h1>
        <h2>{t('subtitle')}</h2>

        <StripeProvider stripe={stripe}>
          <Elements>
            <CardForm />
          </Elements>
        </StripeProvider>
      </div>
    );
  }
}

Form.propTypes = {
  t: PropTypes.func,
  country: PropTypes.string,
  className: PropTypes.string,
};

Form.defaultProps = {
  country: '',
  t: (t) => t,
  className: '',
};

export default Form;
